import _ from 'lodash';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { connect } from 'react-redux';
import * as LockActions from '../../redux/actions/lock.actions';
import EmptyView from '../EmptyView.jsx';
import ListLoadingView from '../ListLoadingView.jsx';
import LockDetailsRow from './LockDetailsRow.jsx';


@connect((state) => ({
  locks: state.locks,
  viewLoading: state.utils.viewLoading,
  themeName: state.settings.items.theme.data.themeName,
}))
class LocksListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingMore: false
    };
  }

  componentWillUnmount() {
    this.closeOperationalSection();
  }

  closeOperationalSection() {
    const { dispatch } = this.props;
    dispatch(LockActions.setOperationalMode(false));
  }

  async handleLoadMore(page) {
    const { onAppendLocks, viewLoading } = this.props;
    const { isLoadingMore } = this.state;
    
    if (isLoadingMore || viewLoading) {
      return;
    }

    this.setState({ isLoadingMore: true });
    await onAppendLocks(page);
    this.setState({ isLoadingMore: false });
  }

  render() {
    const { locks: { data: { content: locksData, pagination: { number: currentPage, totalPages } } }, locks: { selectedLock }, listContainerStyle, onAppendLocks, onOpenLock, viewLoading, onSelectLock } = this.props;
    const smartLocks = _.uniqBy(locksData, 'id');
    return (
        <div className="list-view details-section" style={{ top: 190, paddingBottom: 40, width: '90%', ...listContainerStyle }}>
          <InfiniteScroll
            initialLoad={false}
            loadMore={() => this.handleLoadMore(currentPage + 1)}
            hasMore={!viewLoading && currentPage + 1 < totalPages}
            loader={<ListLoadingView key={0} />}
            useWindow={false}
            threshold={250}
          >
            <div className="r-full-width-phone" style={{ width: '40%' }}>
              {!_.isEmpty(smartLocks) ?
                _.map(smartLocks, lock =>
                  <LockDetailsRow
                    key={lock.id}
                    lock={lock}
                    isSelected={selectedLock && selectedLock.id === lock.id}
                    onClick={() => onSelectLock(lock)}
                    onOpenLock={() => onOpenLock(lock)}
                  />) : (
                    <div>
                      {!viewLoading ? (
                        <EmptyView
                          title="noLock"
                          iconName="icon-simple-line-icons-lock"
                          subtitle="startAddLock"
                        />) : <ListLoadingView />}
                    </div>
                  )
              }
            </div>
          </InfiniteScroll>
        </div>
    );
  }
}

export default LocksListView;